import {createExternalImgIn, setElementInnerHTML, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils.ts'
import {UIHeaderProfileController} from './UIHeaderProfileController.ts'
import {UICoinsController} from '../../../../shared/scripts/ui_coins/UICoinsController.ts'
import {UIHeaderController} from '../../../../shared/scripts/ui_html/header/UIHeaderController.ts'
import {removeURLParams} from '../../../../shared/scripts/ui_utils/Utils.ts'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'
import {stripOAuthTokenFromUrl} from '../../../../shared/scripts/ui_utils/TestableClientUtils.ts'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables.ts'
import IconX from '@static/images/icon_x.svg'
import IconHamburger from '@static/images/icon_hamburger.svg'

type MenuState = 'closed' | 'open'

export class UIWHeaderController extends UIHeaderController {
    private readonly header: HTMLDivElement

    readonly headerProfileController: UIHeaderProfileController

    private readonly mobileHamburger: HTMLDivElement
    private readonly mobileSidebarOverlay: HTMLDivElement
    private readonly mobileSidebar: HTMLDivElement
    private mobileSidebarState: MenuState = 'closed'

    private readonly logoButton: HTMLDivElement
    private logoClickCallback?: () => void

    constructor() {
        super()

        this.header = document.getElementById('web-header') as HTMLDivElement

        this.mobileHamburger = document.getElementById('header-element-hamburger-left') as HTMLDivElement
        this.mobileSidebarOverlay = document.getElementById('web-mobile-sidebar-overlay') as HTMLDivElement
        this.mobileSidebar = document.getElementById('web-mobile-sidebar') as HTMLDivElement

        this.logoButton = document.getElementById('web-header-logo') as HTMLDivElement

        this.headerProfileController = new UIHeaderProfileController()

        this.initLogoClick()
        this.initSidebarDrawer()

        new UICoinsController()

        stripOAuthTokenFromUrl()
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams()
    }

    hide() {
        this.header.classList.add('hidden')
    }

    show() {
        this.header.classList.remove('hidden')
    }

    private initLogoClick() {
        setElementOnClick(this.logoButton, () => {
            if(this.logoClickCallback) {
                this.logoClickCallback()
            }
        })
    }

    setLogoClickCallback(callback: () => void) {
        this.logoClickCallback = callback
    }

    private initSidebarDrawer() {
        setElementOnClick(this.mobileHamburger, () => {
            this.mobileSidebarState == 'open' ? this.closeMobileSidebar() : this.openMobileSidebar()
        })
        setElementOnClick(this.mobileSidebarOverlay, () => this.closeMobileSidebar())
    }

    private openMobileSidebar() {
        if(this.mobileSidebarState == 'open') return
        this.mobileSidebar.classList.add('open')
        this.mobileSidebarOverlay.classList.add('open')
        this.mobileSidebarState = 'open'
        this.setMobileHamburgerIcon()
    }

    closeMobileSidebar() {
        if(this.mobileSidebarState == 'closed') return
        this.mobileSidebar.classList.remove('open')
        this.mobileSidebarOverlay.classList.remove('open')
        this.mobileSidebarState = 'closed'
        this.setMobileHamburgerIcon()
    }

    private setMobileHamburgerIcon() {
        setElementInnerHTML(this.mobileHamburger, {key: 'strings:colonistCommon.utils.emptyString'})
        const icon = this.mobileSidebarState == 'open' ? IconX : IconHamburger
        createExternalImgIn(this.mobileHamburger, icon, {key: 'strings:homePage.header.menu'})
    }

    // eslint-disable-next-line class-methods-use-this
    protected handleShuffleLink(link: HTMLLinkElement) {
        // eslint-disable-next-line no-restricted-syntax
        link.addEventListener('click', async(event) => {
            event.preventDefault()
            await UIWHeaderController.sendPlayNowClickAnalytic()
            if(!UIUtilsEjsVariables.isUserOnDiscord) window.location.href = link.href
        })
    }

    private static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('login-popup')) return

        new ViewPopupLogin()
        removeURLParams()
    }
}
